import axios from 'axios'
import UserProfile from '../models/userProfile'

const apiURL = process.env.REACT_APP_API_URL
const tokenKey = 'nbToken'

export const saveToken = (
  access_token: string,
  token_type: string,
  expires_at: string
) => {
  const expire_time = new Date(expires_at).getTime()
  const payload = {
    access_token,
    token_type,
    expire_time
  }

  localStorage.setItem(tokenKey, JSON.stringify(payload))
}

export const getToken = () => {
  const raw = localStorage.getItem(tokenKey)
  if (!raw) {
    return undefined
  }

  const payload = JSON.parse(raw)

  if (
    typeof payload.access_token !== 'string' ||
    typeof payload.expire_time !== 'number' ||
    typeof payload.token_type !== 'string'
  ) {
    return undefined
  }

  return payload
}

export const setAxiosAuthorization = (
  accessToken: string,
  tokenType: string
) => {
  axios.defaults.headers.common.Authorization = `${tokenType} ${accessToken}`
}

export const clearAxiosAuthorization = () => {
  axios.defaults.headers.common.Authorization = undefined
}

export const clearLocalStorage = () => {
  localStorage.removeItem(tokenKey)
}

export interface LoginRequestDto {
  email: string
  password: string
}

export interface LoginResponseDto {
  access_token: string
  expires_at: string
  token_type: string
  user: UserProfile
}

export const login = async (
  request: LoginRequestDto
): Promise<LoginResponseDto> => {
  const loginURL = `${apiURL}/auth/login`

  const data = await axios.post(loginURL, request)
  saveToken(data.data.access_token, data.data.token_type, data.data.expires_at)
  setAxiosAuthorization(data.data.access_token, data.data.token_type)

  return data.data
}

export const logout = async () => {
  const logoutURL = `${apiURL}/auth/logout`

  await axios.get(logoutURL)
}
